import { Component } from '@angular/core';

@Component({
    selector: 'app-layout-floating-center',
    templateUrl: './floating-center.component.html',
    styleUrls: ['./floating-center.component.scss'],
})
export class LayoutFloatingCenterComponent {}
